@if (initialized && formGroup) {

  <form [formGroup]="formGroup" autocomplete="off">
    <div class="grid">

      <div class="col-12 flex flex-column mb-3">
        <label for="email" class="font-medium text-900 mb-2">Email</label>
        <div class="p-input-icon-left">
                <i class="pi pi-user"></i>
              <input id="email" formControlName="email" type="text" class="w-full" pInputText>
          </div>
      </div>

      <div class="col-12">
        <label for="password" class="font-medium text-900 mb-2 block">Passwort</label>
        <div style="height: 0; overflow: hidden;">
          <input type="password" name="fakePassword" autocomplete="new-password" tabindex="-1"/>
        </div>
        <p-password id="password" formControlName="password"
                    placeholder="Passwort eingeben" styleClass="w-full"
                    inputStyleClass="w-full"
                    autoComplete="new-password"
                    [toggleMask]="true" [feedback]="false"
                    autocomplete="new-password"></p-password>
      </div>

    </div>

    <div class="flex justify-content-end mt-5">
<!--      <button class="w-10rem" pButton [disabled]="!formGroup.valid" (click)="updateEmail()" pRipple-->
<!--              label="Speichern"></button>-->

      <app-button [busy]="busy"
                  [disabled]="!formGroup.valid"
                  [label]="'Speichern'"
                  [class]="'w-10rem'"
                  [showIcon]="false"
                  (onClick)="updateEmail()">
      </app-button>

    </div>

  </form>
}
